// src\components\Video\VideoList.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const VideoList = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const [activeTab, setActiveTab] = useState('全部节目');
  const [searchTerm, setSearchTerm] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('全部');
  const [durationFilter, setDurationFilter] = useState('全部');
  const [sortBy, setSortBy] = useState('默认排序');
  const [isSearchFocused, setIsSearchFocused] = useState(false);

  // 检测屏幕宽度
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // 模拟视频数据
  const videos = [
    {
      id: 1,
      title: '非遗故事——鸟哨',
      host: '声声',
      category: '传统',
      duration: '03:09',
      durationMinutes: 3.15,
      resolution: 'HD',
      views: '1.2万',
      uploadDate: '2024-03-15',
      rating: 4.8,
      thumbnail: 'https://picsum.photos/id/20/300/200',
      description: '本片记录了国家级非物质文化遗产"鸟哨"的传承故事。',
      videoUrl: 'https://www.w3schools.com/html/mov_bbb.mp4'
    },
    {
      id: 2,
      title: '为什么天空是蓝色的',
      host: '立达',
      category: '科普',
      duration: '08:45',
      durationMinutes: 8.75,
      resolution: '4K',
      views: '2.5万',
      uploadDate: '2024-03-10',
      rating: 4.6,
      thumbnail: 'https://picsum.photos/id/21/300/200',
      description: '探索天空颜色的科学原理。',
      videoUrl: 'https://www.w3schools.com/html/mov_bbb.mp4'
    },
    {
      id: 3,
      title: '穿越亿年，探寻恐龙的神秘世界',
      host: '王青',
      category: '科普',
      duration: '15:54',
      durationMinutes: 15.9,
      resolution: 'HD',
      views: '3.8万',
      uploadDate: '2024-03-05',
      rating: 4.9,
      thumbnail: 'https://picsum.photos/id/22/300/200',
      description: '一起探索恐龙的奥秘。',
      videoUrl: 'https://www.w3schools.com/html/mov_bbb.mp4'
    },
    {
      id: 4,
      title: '天下第一行书《兰亭集序》',
      host: '卢林平',
      category: '艺术',
      duration: '08:03',
      durationMinutes: 8.05,
      resolution: 'HD',
      views: '1.8万',
      uploadDate: '2024-02-28',
      rating: 4.7,
      thumbnail: 'https://picsum.photos/id/23/300/200',
      description: '赏析王羲之的千古名作。',
      videoUrl: 'https://www.w3schools.com/html/mov_bbb.mp4'
    },
    {
      id: 5,
      title: '非遗——白蛇传',
      host: '声声',
      category: '传统',
      duration: '01:41',
      durationMinutes: 1.68,
      resolution: 'HD',
      views: '3.2万',
      uploadDate: '2024-02-20',
      rating: 4.8,
      thumbnail: 'https://picsum.photos/id/24/300/200',
      description: '中国传统民间故事《白蛇传》的精彩演绎。',
      videoUrl: 'https://www.w3schools.com/html/mov_bbb.mp4'
    },
    {
      id: 6,
      title: '发生山火时，我们该如何自救？',
      host: '丁忆',
      category: '科普',
      duration: '05:24',
      durationMinutes: 5.4,
      resolution: 'HD',
      views: '4.1万',
      uploadDate: '2024-02-15',
      rating: 4.5,
      thumbnail: 'https://picsum.photos/id/25/300/200',
      description: '学习山火发生时的正确自救方法。',
      videoUrl: 'https://www.w3schools.com/html/mov_bbb.mp4'
    },
    {
      id: 7,
      title: '中国传统节日——春节的由来',
      host: '李华',
      category: '传统',
      duration: '12:30',
      durationMinutes: 12.5,
      resolution: 'HD',
      views: '2.3万',
      uploadDate: '2024-02-10',
      rating: 4.7,
      thumbnail: 'https://picsum.photos/id/26/300/200',
      description: '了解春节的历史渊源。',
      videoUrl: 'https://www.w3schools.com/html/mov_bbb.mp4'
    },
    {
      id: 8,
      title: '探索宇宙的奥秘：黑洞',
      host: '张明',
      category: '科普',
      duration: '20:15',
      durationMinutes: 20.25,
      resolution: '4K',
      views: '5.6万',
      uploadDate: '2024-02-05',
      rating: 4.9,
      thumbnail: 'https://picsum.photos/id/27/300/200',
      description: '深入探索宇宙中最神秘的天体。',
      videoUrl: 'https://www.w3schools.com/html/mov_bbb.mp4'
    },
    {
      id: 9,
      title: '古诗词鉴赏——静夜思',
      host: '王芳',
      category: '文学',
      duration: '04:20',
      durationMinutes: 4.33,
      resolution: 'HD',
      views: '1.5万',
      uploadDate: '2024-01-28',
      rating: 4.6,
      thumbnail: 'https://picsum.photos/id/28/300/200',
      description: '品读李白的千古名篇。',
      videoUrl: 'https://www.w3schools.com/html/mov_bbb.mp4'
    },
    {
      id: 10,
      title: '手工制作：中国传统剪纸艺术',
      host: '赵敏',
      category: '艺术',
      duration: '15:20',
      durationMinutes: 15.33,
      resolution: 'HD',
      views: '2.1万',
      uploadDate: '2024-01-20',
      rating: 4.7,
      thumbnail: 'https://picsum.photos/id/29/300/200',
      description: '学习中国传统剪纸艺术的制作技巧。',
      videoUrl: 'https://www.w3schools.com/html/mov_bbb.mp4'
    },
    {
      id: 11,
      title: '时事热点：环保与可持续发展',
      host: '陈思',
      category: '时事',
      duration: '18:45',
      durationMinutes: 18.75,
      resolution: 'HD',
      views: '3.4万',
      uploadDate: '2024-01-15',
      rating: 4.8,
      thumbnail: 'https://picsum.photos/id/30/300/200',
      description: '探讨环保与可持续发展的重要性。',
      videoUrl: 'https://www.w3schools.com/html/mov_bbb.mp4'
    },
    {
      id: 12,
      title: '历史故事：丝绸之路的传奇',
      host: '林峰',
      category: '知识',
      duration: '22:10',
      durationMinutes: 22.17,
      resolution: 'HD',
      views: '4.2万',
      uploadDate: '2024-01-10',
      rating: 4.9,
      thumbnail: 'https://picsum.photos/id/31/300/200',
      description: '追溯丝绸之路的历史足迹。',
      videoUrl: 'https://www.w3schools.com/html/mov_bbb.mp4'
    },
  ];

  const handleVideoClick = (video) => {
    navigate(`/video/${video.id}`, { state: { video } });
  };

  const tabs = ['全部节目', '官方节目', '共创节目', '学生节目'];
  const categories = ['全部', '科普', '知识', '文学', '艺术', '传统', '时事', '素材', '其他', '合集'];
  const durations = ['全部', '3分钟以下', '3-5分钟', '5-10分钟', '10-20分钟', '20分钟以上'];
  
  const sortOptions = [
    { value: '默认排序', label: '默认排序' },
    { value: '最新上传', label: '最新上传' },
    { value: '最多播放', label: '最多播放' },
    { value: '评分最高', label: '评分最高' },
    { value: '时长最短', label: '时长最短' },
    { value: '时长最长', label: '时长最长' },
  ];

  const filteredAndSortedVideos = () => {
    let filtered = videos.filter(video => {
      const matchesSearch = video.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            video.host.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesCategory = categoryFilter === '全部' || video.category === categoryFilter;
      
      let matchesDuration = true;
      if (durationFilter === '3分钟以下') {
        matchesDuration = video.durationMinutes < 3;
      } else if (durationFilter === '3-5分钟') {
        matchesDuration = video.durationMinutes >= 3 && video.durationMinutes <= 5;
      } else if (durationFilter === '5-10分钟') {
        matchesDuration = video.durationMinutes > 5 && video.durationMinutes <= 10;
      } else if (durationFilter === '10-20分钟') {
        matchesDuration = video.durationMinutes > 10 && video.durationMinutes <= 20;
      } else if (durationFilter === '20分钟以上') {
        matchesDuration = video.durationMinutes > 20;
      }
      
      return matchesSearch && matchesCategory && matchesDuration;
    });

    switch (sortBy) {
      case '最新上传':
        filtered.sort((a, b) => new Date(b.uploadDate) - new Date(a.uploadDate));
        break;
      case '最多播放':
        filtered.sort((a, b) => parseInt(b.views) - parseInt(a.views));
        break;
      case '评分最高':
        filtered.sort((a, b) => b.rating - a.rating);
        break;
      case '时长最短':
        filtered.sort((a, b) => a.durationMinutes - b.durationMinutes);
        break;
      case '时长最长':
        filtered.sort((a, b) => b.durationMinutes - a.durationMinutes);
        break;
      default:
        filtered.sort((a, b) => a.id - b.id);
    }
    
    return filtered;
  };

  const displayedVideos = filteredAndSortedVideos();

  const [currentPage, setCurrentPage] = useState(1);
  const videosPerPage = 12;
  const totalPages = Math.ceil(displayedVideos.length / videosPerPage);
  const currentVideos = displayedVideos.slice(
    (currentPage - 1) * videosPerPage,
    currentPage * videosPerPage
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, categoryFilter, durationFilter, sortBy]);

  return (
    <div style={{
      ...styles.videoListPage,
      ...(isMobile ? styles.videoListPageMobile : {})
    }}>
      {/* 顶部导航 - YouTube风格 */}
      <div style={styles.topSection}>
        <div style={styles.navTabs}>
          {tabs.map(tab => (
            <button
              key={tab}
              style={{
                ...styles.navTab,
                ...(activeTab === tab ? styles.navTabActive : {})
              }}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
        
        {/* 搜索栏 - 透明风格 */}
        <div style={{
          ...styles.searchWrapper,
          ...(isSearchFocused ? styles.searchWrapperFocused : {})
        }}>
          <span style={styles.searchIcon}>🔍</span>
          <input
            type="text"
            placeholder="搜索节目..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onFocus={() => setIsSearchFocused(true)}
            onBlur={() => setIsSearchFocused(false)}
            style={styles.searchInput}
          />
        </div>
      </div>

      {/* 筛选栏 - YouTube风格芯片 */}
      <div style={styles.filterBar}>
        <div style={styles.filterChips}>
          <span style={styles.filterLabel}>分类</span>
          {categories.slice(0, isMobile ? 6 : 10).map(cat => (
            <button
              key={cat}
              style={{
                ...styles.filterChip,
                ...(categoryFilter === cat ? styles.filterChipActive : {})
              }}
              onClick={() => setCategoryFilter(cat)}
            >
              {cat}
            </button>
          ))}
        </div>
        
        <div style={styles.filterChips}>
          <span style={styles.filterLabel}>时长</span>
          {durations.map(dur => (
            <button
              key={dur}
              style={{
                ...styles.filterChip,
                ...(durationFilter === dur ? styles.filterChipActive : {})
              }}
              onClick={() => setDurationFilter(dur)}
            >
              {dur}
            </button>
          ))}
        </div>
      </div>

      {/* 统计和排序栏 */}
      <div style={styles.statsBar}>
        <div style={styles.statsInfo}>
          {displayedVideos.length} 个视频
        </div>
        <select 
          style={styles.sortSelect}
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
        >
          {sortOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      {/* 视频网格 - YouTube风格卡片 */}
      <div style={styles.videoGrid}>
        <div style={{
          ...styles.cardsContainer,
          ...(isMobile ? styles.cardsContainerMobile : {})
        }}>
          {currentVideos.map(video => (
            <div 
              key={video.id} 
              style={styles.videoCard}
              onClick={() => handleVideoClick(video)}
            >
              <div style={styles.thumbnailWrapper}>
                <img 
                  src={video.thumbnail} 
                  alt={video.title} 
                  style={styles.thumbnail}
                  onError={(e) => {
                    e.target.src = 'https://picsum.photos/id/1/300/200';
                  }}
                />
                <div style={styles.durationBadge}>{video.duration}</div>
              </div>
              <div style={styles.cardInfo}>
                <h3 style={styles.videoTitle}>{video.title}</h3>
                <p style={styles.channelName}>{video.host}</p>
                <div style={styles.videoStats}>
                  <span>{video.views}次观看</span>
                  <span>•</span>
                  <span>{video.uploadDate}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 分页 - 简洁风格 */}
      {totalPages > 1 && (
        <div style={styles.paginationBar}>
          <button 
            style={{
              ...styles.pageBtn,
              ...(currentPage === 1 ? styles.pageBtnDisabled : {})
            }}
            onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
            disabled={currentPage === 1}
          >
            上一页
          </button>
          <span style={styles.pageInfo}>
            {currentPage} / {totalPages}
          </span>
          <button 
            style={{
              ...styles.pageBtn,
              ...(currentPage === totalPages ? styles.pageBtnDisabled : {})
            }}
            onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
            disabled={currentPage === totalPages}
          >
            下一页
          </button>
        </div>
      )}
    </div>
  );
};

const styles = {
  videoListPage: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    backgroundColor: '#f8f9fa',
    minHeight: '100vh',
    padding: '20px 24px',
  },
  videoListPageMobile: {
    padding: '12px 16px',
  },

  // 顶部区域
  topSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
    flexWrap: 'wrap',
    gap: '16px',
  },
  navTabs: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
  },
  navTab: {
    padding: '8px 16px',
    border: 'none',
    background: 'transparent',
    borderRadius: '24px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    color: '#5f6368',
    transition: 'all 0.2s ease',
  },
  navTabActive: {
    background: '#0f0f0f',
    color: 'white',
  },

  // 搜索栏 - 透明风格
  searchWrapper: {
    display: 'flex',
    alignItems: 'center',
    background: '#f0f0f0',
    borderRadius: '24px',
    padding: '6px 16px',
    transition: 'all 0.2s ease',
    border: '1px solid transparent',
  },
  searchWrapperFocused: {
    background: 'white',
    borderColor: '#1a73e8',
    boxShadow: '0 0 0 2px rgba(26,115,232,0.1)',
  },
  searchIcon: {
    fontSize: '16px',
    color: '#5f6368',
    marginRight: '8px',
  },
  searchInput: {
    border: 'none',
    background: 'transparent',
    outline: 'none',
    fontSize: '14px',
    width: '240px',
    padding: '6px 0',
    color: '#1f1f1f',
  },

  // 筛选栏
  filterBar: {
    marginBottom: '24px',
    borderBottom: '1px solid #e5e5e5',
    paddingBottom: '16px',
  },
  filterChips: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '12px',
  },
  filterLabel: {
    fontSize: '13px',
    fontWeight: '500',
    color: '#5f6368',
    marginRight: '4px',
  },
  filterChip: {
    padding: '6px 14px',
    border: '1px solid #e0e0e0',
    background: 'white',
    borderRadius: '24px',
    cursor: 'pointer',
    fontSize: '13px',
    color: '#1f1f1f',
    transition: 'all 0.2s ease',
  },
  filterChipActive: {
    background: '#0f0f0f',
    borderColor: '#0f0f0f',
    color: 'white',
  },

  // 统计栏
  statsBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
  },
  statsInfo: {
    fontSize: '14px',
    color: '#5f6368',
  },
  sortSelect: {
    padding: '6px 12px',
    border: '1px solid #e0e0e0',
    borderRadius: '20px',
    background: 'white',
    fontSize: '13px',
    color: '#1f1f1f',
    cursor: 'pointer',
    outline: 'none',
  },

  // 视频网格
  videoGrid: {
    marginBottom: '40px',
  },
  cardsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
    gap: '24px',
  },
  cardsContainerMobile: {
    gridTemplateColumns: '1fr',
    gap: '16px',
  },

  // 视频卡片 - YouTube风格
  videoCard: {
    cursor: 'pointer',
    transition: 'transform 0.2s ease',
  },
  thumbnailWrapper: {
    position: 'relative',
    width: '100%',
    paddingTop: '56.25%',
    overflow: 'hidden',
    borderRadius: '12px',
    marginBottom: '12px',
  },
  thumbnail: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  durationBadge: {
    position: 'absolute',
    bottom: '8px',
    right: '8px',
    background: 'rgba(0,0,0,0.8)',
    color: 'white',
    padding: '2px 6px',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: '500',
  },
  cardInfo: {
    padding: '0 4px',
  },
  videoTitle: {
    fontSize: '15px',
    margin: '0 0 6px 0',
    color: '#1f1f1f',
    lineHeight: '1.4',
    fontWeight: '500',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
  },
  channelName: {
    fontSize: '13px',
    color: '#606060',
    margin: '0 0 4px 0',
  },
  videoStats: {
    display: 'flex',
    gap: '6px',
    fontSize: '12px',
    color: '#909090',
  },

  // 分页栏
  paginationBar: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '16px',
    padding: '24px 0',
    borderTop: '1px solid #e5e5e5',
    marginTop: '24px',
  },
  pageBtn: {
    padding: '8px 20px',
    background: 'transparent',
    border: '1px solid #e0e0e0',
    borderRadius: '24px',
    cursor: 'pointer',
    fontSize: '14px',
    color: '#1f1f1f',
    transition: 'all 0.2s ease',
  },
  pageBtnDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
  pageInfo: {
    fontSize: '14px',
    color: '#5f6368',
  },
};

export default VideoList;